import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';
import AutumnLeaf from '../../../../assets/seasons/ChallengeButton/autumnleaf.webp';
import SpringLeaf from '../../../../assets/seasons/ChallengeButton/springleaf.webp';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
      borderRadius: palette.borderRadius.default,
      transition: '0.3s ease',
      color: palette.text.white,
      fontWeight: 700,
      fontSize: '1rem',
      height: '44px',
      paddingLeft: '10px',
      paddingRight: '10px',
      boxShadow: palette.shadows.buttonShadow,
      textShadow: palette.shadows.textShadow,
      border: 'none',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%, cover',
      '@media (max-width: 440px)': {
        borderRadius: '0px 10px 10px 0px',
        fontSize: '0.8rem'
      },
      '@media (max-width: 370px)': {
        fontSize: '0.6rem'
      },
      '&:hover': {
        transform: 'scale(1.1)',
        backgroundSize: '140% 140%, cover'
      },
      cursor: 'pointer'
    },
    default: {
      background: palette.text.primary
    },
    autumn: {
      backgroundImage: `url(${AutumnLeaf})`,
      backgroundColor: palette.background.autumn
    },
    spring: {
      backgroundImage: `url(${SpringLeaf})`,
      backgroundColor: palette.background.spring
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
